class LoyaltyVideo extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    this.handlePlay = this.handlePlay.bind(this)
    this.handlePause = this.handlePause.bind(this)
    this.handleProgress = this.handleProgress.bind(this)
    this.handleFinished = this.handleFinished.bind(this)

    this.listeners.add(this.els.play.element, 'click', this.handlePlay)
    this.listeners.add(this.els.pause.element, 'click', this.handlePause)

    this.listeners.add(
      this.els.video.element,
      'timeupdate',
      this.handleProgress,
    )
    this.listeners.add(this.els.video.element, 'ended', this.handleFinished)
  }

  handlePlay () {
    this.els.video.element.play()

    this.els.play.element.setAttribute('aria-hidden', true)
    this.els.pause.element.setAttribute('aria-hidden', false)
  }

  handlePause () {
    this.els.video.element.pause()

    this.els.play.element.setAttribute('aria-hidden', false)
    this.els.pause.element.setAttribute('aria-hidden', true)
  }

  handleProgress () {
    const totalTime = this.els.video.element.duration
    const currentTime = this.els.video.element.currentTime

    if (currentTime === 0) {
      this.els.progress.element.style.setProperty('--Progress', '0')
    } else {
      const currentPercent = parseFloat(currentTime / totalTime).toFixed(4)

      this.els.progress.element.style.setProperty('--Progress', currentPercent)
    }
  }

  handleFinished () {
    this.els.progress.element.style.setProperty('--Progress', '1')

    this.els.play.element.setAttribute('aria-hidden', false)
    this.els.pause.element.setAttribute('aria-hidden', true)
  }
}

if (!customElements.get('loyalty-video')) {
  customElements.define('loyalty-video', LoyaltyVideo)
}
